function createNamedWrapperReducer(reducerFunction, reducerUniqueKey) {
  return (state, action) => {
    const { uniqueAppModuleInstanceKey = "" } = action || {};
    const isInitializationCall = state === void 0;
    if (uniqueAppModuleInstanceKey !== reducerUniqueKey && !isInitializationCall)
      return state;
    return reducerFunction(state, action);
  };
}
export {
  createNamedWrapperReducer
};
//# sourceMappingURL=AppModuleReducerUtils.js.map
